import React, {useState,Suspense,lazy,useContext} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { Modal } from "react-bootstrap";
import { Loading } from '@gull';
import { IsAuthContext } from 'app/App';
import {buildPublicDocumentUrl} from '../form/publicDocumentUrl';

const SendDocumentEmailForm = lazy(() => import('../form/SendDocumentEmailForm'));

// Configuration par type de document : endpoint mail_*_b2c, nature du token de consultation publique,
// et pour le ticket, ajout de l'URL de consultation de sa facture (comme SendTicketEmailForm)
const DOCUMENT_CONFIG = {
    ticket: {mailPath:'mail_b2c', publicKind:'ticket', withFacture:true},
    commande: {mailPath:'mail_commande_b2c', publicKind:'commande'},
    devis: {mailPath:'mail_devis_b2c', publicKind:'devis'},
}

/**
 * Bouton (icône ou bouton texte) ouvrant la modale d'envoi par e-mail d'un document B2C
 * (ticket, commande ou devis). Ne s'affiche pas pour une commande annulée, ni si le document
 * n'a pas de ticket lié (pas de token). Un devis expiré reste envoyable.
 *
 * @param {'ticket'|'commande'|'devis'} type - Type de document
 * @param {Object} document - Le ticket, la commande ou le devis. Pour un ticket, le token/section_id/client
 *   sont portés directement par l'objet ; pour une commande/un devis, ils sont sur son .ticket imbriqué.
 * @param {'icon'|'button'} [variant='icon'] - Forme d'affichage du déclencheur
 * @param {number} [index] - Index utilisé pour l'id de tooltip (variante icon)
 * @param {string} [className] - Classes du bouton (variante button), à aligner avec les boutons voisins
 */
const SendB2cMailBtn = ({type,document:doc,variant='icon',index,className='btn btn-sm btn-secondary'}) => {
    const t = useTranslate();
    const [show,setShow]=useState(false)
    const { authParam } = useContext(IsAuthContext)

    const config = DOCUMENT_CONFIG[type]
    // Le ticket porte lui-même son token/section_id/client ; commande et devis les portent sur leur ticket lié
    const ticketRef = (type=='ticket') ? doc : doc.ticket

    // Règles métier : pas d'envoi pour une commande annulée, ni sans ticket lié (le document ne peut pas être consulté publiquement)
    if(type=='commande' && doc.cancel) return null
    if(!ticketRef || !ticketRef.token) return null

    const urls = {
        url:buildPublicDocumentUrl(config.publicKind, doc.id, ticketRef.token, authParam),
    }
    if(config.withFacture){
        urls.url_facture = buildPublicDocumentUrl('ticket_facture', doc.id, ticketRef.token, authParam)
    }

    return(<>
        <Modal show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{t('sendDocEmail')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Suspense fallback={<Loading></Loading>}>
                    <SendDocumentEmailForm
                        mailPath={config.mailPath+"/"+doc.id}
                        urls={urls}
                        sectionId={ticketRef.section_id}
                        client={ticketRef.client}
                        closeModal={()=>setShow(false)}
                    />
                </Suspense>
            </Modal.Body>
        </Modal>
        {(variant=='icon') ?
            <OverlayTrigger
                placement="bottom"
                overlay={
                    <Tooltip id={`tooltip-send-mail-${index}`}>
                        {t('btnSendMailTicket')}
                    </Tooltip>
                }
            >
                <span onClick={() => setShow(true)} style={{cursor:'Pointer'}}><FontAwesomeIcon icon={faPaperPlane} /></span>
            </OverlayTrigger>
        :
            <button className={className} onClick={()=>setShow(true)}>{t('btnSendMailTicket')}&nbsp;<FontAwesomeIcon icon={faPaperPlane} /></button>
        }
    </>)
}

export default SendB2cMailBtn;
